export const dataset = [
    {
      siddesh: 59,
      lovkush: 57,
      month: 'Jan',
    },
    {
      siddesh: 50,
      lovkush: 52,
      month: 'Feb',
    },
    {
      siddesh: 47,
      lovkush: 53,
      month: 'Mar',
    },
    {
      siddesh: 54,
      lovkush: 56,
      month: 'Apr',
    },
    {
      siddesh: 57,
      lovkush: 69,
      month: 'May', 
    },
    {
      siddesh: 60,
      lovkush: 63,
      month: 'June',
    },
    {
      siddesh: 59,
      lovkush: 60,
      month: 'July',
    },
    {
      siddesh: 65,
      lovkush: 60,
      month: 'Aug',
    },
    {
      siddesh: 51,
      lovkush: 51,
      month: 'Sept',
    },
    {
      siddesh: 60,
      lovkush: 65,
      month: 'Oct',
    },
    {
      siddesh: 67,
      lovkush: 64,
      month: 'Nov',
    },
    {
      siddesh: 61,
      lovkush: 70,
      month: 'Dec',
    },
  ];
  
  export function valueFormatter(value: number | null) {
    console.log(value)
    return `${value} Sale`;
  }